import { gql } from '@apollo/client';

export const CREATE_AGENT_PROMPT = gql`
  mutation CreateAgentPrompt($params: CreateAgentPromptInput) {
    createAgentPrompt(params: $params) {
      success
      message
      errors
      data {
        id
        agentConfigId
        businessDomain
        systemRole
        mainTask
        instructions
        restrictions
        responseFormatRules
        promptInput
        contextVariables
        fewShotExamples
        isActive
        createdAt
        createdBy
      }
    }
  }
`;

export const UPDATE_AGENT_PROMPT = gql`
  mutation UpdateAgentPrompt($params: UpdateAgentPromptInput) {
    updateAgentPrompt(params: $params) {
      success
      message
      errors
      data {
        id
        agentConfigId
        businessDomain
        systemRole
        mainTask
        instructions
        restrictions
        responseFormatRules
        promptInput
        contextVariables
        fewShotExamples
        isActive
        createdAt
        createdBy
      }
    }
  }
`;

export const DELETE_AGENT_PROMPT = gql`
  mutation DeleteAgentPrompt($params: DeleteAgentPromptInput) {
    deleteAgentPrompt(params: $params) {
      success
      message
      errors
    }
  }
`;
